module.exports = __webpack_public_path__ + "static/media/selectArrow.7a2eb8dd.svg";